export function isSocialShareOgPreview(contentKey?: string): boolean {
  return contentKey === 'social-share-preview';
}
